<script lang="ts">
	import { page } from '$app/stores'
	import type { MenuItem } from '$lib/app/header/types/menu-item.type'

	interface Props {
		href: MenuItem['href'];
		children?: import('svelte').Snippet;
	}

	let { href, children }: Props = $props();
</script>

<a
	{href}
	class="inline-flex w-full gap-2 py-2 pl-3 pr-4 rounded-xl md:p-0 hover:bg-lilac-200 md:text-gray-900 md:hover:bg-transparent md:bg-transparent hover:md:text-lilac-500 transition-colors"
	class:text-white={$page.url.pathname === href}
	class:bg-lilac-100={$page.url.pathname === href}
	aria-current="page">{@render children?.()}</a
>
